import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import HomeScreen from '../screens/HomeScreen';

function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={HomeScreen} />
      </Switch>
    </Router>
  )
}

export default Routes



// WEBPACK FOOTER //
// ./src/routes/index.js